module.exports = __webpack_public_path__ + "static/media/RRD1.cd0ed331.jpg";